import { forwardRef, memo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { isEmpty, isNil, isString, noop, trim } from 'lodash';
import type { FormikErrors } from 'formik';
// Import Constants
import { l } from 'constants/common';
// Import Styles
import 'assets/scss/uploadFile.scss';

interface Props {
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    showOnlyButton?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorText?: string | string[] | FormikErrors<any> | FormikErrors<any>[] | undefined;
    buttonTextKey?: string;
    inputTitle?: string;
    acceptedExtensions?: string;
}

const UploadFile = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const {
        value = null,
        onChange = noop,
        disabled,
        errorText = '',
        buttonTextKey = l.Browse,
        showOnlyButton,
        inputTitle = '',
        acceptedExtensions = '.xls,.xlsx,.csv',
    } = props;
    const { t } = useTranslation();

    return (
        <div className={inputTitle ? 'extension-input-filed-el' : ''} data-title={t(l.P12Certificate)}>
            <div
                className={`crm-uploader-block-wrapper ${disabled ? 'disabled' : ''} ${
                    errorText ? 'browse-file-input' : ''
                }`}
            >
                {!showOnlyButton && (
                    <div className="crm-uploader-block-data">
                        <p className={classNames({ 'is-placeholder': !value })}>
                            {isNil(value) || !isString(value) || isEmpty(trim(value)) ? t(l.NoFileChosen) : value}
                        </p>
                    </div>
                )}
                <label
                    className={classNames('crm-uploader-button', {
                        'crm-uploader-button-show-only-button': showOnlyButton,
                    })}
                >
                    <input type="file" ref={ref} onChange={onChange} disabled={disabled} accept={acceptedExtensions} />
                    <span>{t(buttonTextKey)}</span>
                </label>
                {errorText && <p className="information-message color-danger choose-file">{errorText}</p>}
            </div>
        </div>
    );
});

UploadFile.displayName = 'UploadFile';

export default memo(UploadFile);
